import "../main.css"
import React from "react"
import "@fontsource/roboto"
import Login from "./Login"
import { Container } from "react-bootstrap"
import NotificationToaster from "./NotificationToaster"
import Dashboard from "../../Component/Dashboard/Dashboard"
import UsersManager from "../../Component/User/UsersManager"
import Navigation from "./Navigation"
import ForgotPassword from "./ForgotPassword"
import Todo from "../../Component/Todo/Todo"
import MyProfileForm from "../../Component/MyProfile/MyProfileForm"
import withHooks from "./WithHooks"
import QuestionTypesManager from "../../Component/QuestionType/QuestionTypesManager"
import ResponseTypesManager from "../../Component/ResponseType/ResponseTypesManager"
import QuestionManager from "../../Component/Question/QuestionsManager"
import ResponseChoicesManager from "../../Component/ResponseChoice/ResponseChoicesManager"
import StatisticsManager from "../../Component/Statistic/StatisticsManager"
import Splash from "../../ComponentPublic/Splash/Splash"
import Play from "../../ComponentPublic/Play/Play"
import { pyLog } from "../js/pyLog"

class MainApp extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    this.pylog = this.props.router.params.pylog
    this.dMgr.debug("pylog:", this.pylog)

    this.forgot_password_token = this.props.router.params.forgot_password_token
    this.dMgr.debug("forgot_password_token:", this.forgot_password_token)

    this.state = {
      loggedIn: false,
      entityPage: this.props.entityPage,
      pageType: this.props.pageType !== undefined ? this.props.pageType : "list",
      pageMenu: this.props.pageMenu,
      entityId: this.props.router.params.id !== undefined ? parseInt(this.props.router.params.id) : undefined,
      show: false,
      splashFilterBrightness: 100,
    }
    this.dMgr.debug("init_state:", this.state)

    this.loggedInHandler = this.loggedInHandler.bind(this)
    this.goTo = this.goTo.bind(this)
    this.setSplashFilterBrightness = this.setSplashFilterBrightness.bind(this)
  }

  loggedInHandler() {
    this.dMgr.debug("loggedInHandler:", true)
    this.setState({ loggedIn: true })
  }

  goTo(eventKey) {
    window.history.replaceState(null, null, "/" + eventKey)
    this.setState({ entityPage: eventKey })
  }

  setSplashFilterBrightness(splashFilterBrightness) {
    this.setState({ splashFilterBrightness })
  }

  getDisplayedPage() {
    this.dMgr.debug("getDisplayedPage:", this.state.entityPage)

    switch (this.state.entityPage) {
      default:
      case "splash":
        return <Splash setSplashFilterBrightness={this.setSplashFilterBrightness} />
      case "play":
        return <Play setSplashFilterBrightness={this.setSplashFilterBrightness} entityId={this.state.entityId} />
      case "dashboard":
        return <Dashboard />
      case "my_profile":
        return <MyProfileForm goTo={this.goTo} />
      case "users":
        return <UsersManager pageType={this.state.pageType} entityId={this.state.entityId} />
      case "todo":
        return <Todo />
      case "questions":
        return <QuestionManager pageType={this.state.pageType} entityId={this.state.entityId} />
      case "question_types":
        return <QuestionTypesManager pageType={this.state.pageType} entityId={this.state.entityId} />
      case "response_choices":
        return <ResponseChoicesManager pageType={this.state.pageType} entityId={this.state.entityId} />
      case "response_types":
        return <ResponseTypesManager pageType={this.state.pageType} entityId={this.state.entityId} />
      case "statistics":
        return <StatisticsManager pageType={this.state.pageType} entityId={this.state.entityId} />
    }
  }

  render() {
    this.dMgr.rendering()
    this.dMgr.debug("getDisplayedPage", this.state.entityPage)

    if (this.state.entityPage === "splash" || (this.state.loggedIn && (this.state.entityPage === "play" || this.state.entityPage === "question"))) {
      document.body.style.backgroundColor = "black"

      let toRender = (
        <>
          <div className="background-wrapper">
            <div className={"splash-img filter-brightness-" + this.state.splashFilterBrightness}></div>
            <div className="content-wrapper">
              <Container className="min-height-100vh d-flex flex-column justify-content-center">{this.getDisplayedPage()}</Container>
            </div>
          </div>
          <NotificationToaster />
        </>
      )
      this.dMgr.renderDone()
      return toRender
    } else if (this.state.entityPage === "forgot_password") {
      let variantPage
      if (this.forgot_password_token === undefined) {
        variantPage = "request"
      } else {
        variantPage = "reset"
      }
      this.dMgr.debug("ForgotPassword redirection ", variantPage, this.forgot_password_token)
      return <ForgotPassword variantPage={variantPage} token={this.forgot_password_token} />
    } else if (!this.state.loggedIn) {
      this.dMgr.debug("Not logged in: redirection")

      let autoPyLog = false
      if (this.state.entityPage === "play") {
        autoPyLog = true
      }

      return <Login loggedInHandler={this.loggedInHandler} pylog={this.pylog} autoPyLog={autoPyLog} />
    } else if (this.pylog !== undefined) {
      this.dMgr.debug("Pylog: redirection")
      window.location = "/"
      return null
    } else {
      let toRender = (
        <>
          <Navigation changeLanguage={this.props.changeLanguage} pageType={this.state.pageType} pageMenu={this.state.pageMenu} />
          <Container fluid className="main-container">
            {this.getDisplayedPage()}
          </Container>
          <NotificationToaster />
        </>
      )

      this.dMgr.renderDone()
      return toRender
    }
  }
}

export default withHooks(MainApp)
